/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconTelescope2 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M6.751 23l4.5-7.5M15.751 23l-4.5-7.5M11.251 15.5V23M3.325 10.634l2.314-.944h0l1.134 2.778h0l-2.315.945a.5.5 0 0 1-.652-.274l-.756-1.852a.502.502 0 0 1 .275-.653z" />
        <path d="M5.535 8.112l5.092-2.078h0l2.267 5.555h0l-5.092 2.078a.5.5 0 0 1-.652-.274L5.261 8.764a.5.5 0 0 1 .274-.652zM18.423 1.317a.751.751 0 0 0-1.046-.379L10.66 4.327a.75.75 0 0 0-.343.946l2.888 7.076a.75.75 0 0 0 .907.436l7.171-2.279a.748.748 0 0 0 .481-1l-3.341-8.189zM20.25 14.75v4.5M18 17h4.5M3.75 1.25v4.5M1.5 3.5H6" />
      </g>
    </svg>
  ),
);
